const ROTULOS = {
  CODPAC: 'Código',
  NOMEPAC: 'Nome',
  ENDMARPAC: 'CPF',
  DTNPAC: 'Data Nasc',
  SEXOPAC: 'Sexo',
  CODINTERNADO: 'Nr Carteirinha',
  VALIDADE: 'Validade',
  PROFISSPAC: 'Profissão',
  EMPRESA: 'Empresa',
  CEPPAC: 'CEP',
  ENDRESPAC: 'Endereço',
  ENDERECO_NR: 'Número',
  ENDERECO_COMPL: 'Complemento',
  CIDADEPAC: 'Cidade',
  BAIRROPAC: 'Bairro',
  ESTADOPAC: 'Estado',
  FONERESPAC: 'Fone Residencial',
  FONECOMPAC: 'Fone Comercial',
  FONERECPAC: 'Fone Agendamento',
  RAMALPAC: 'Obs Fone',
  CELULARPAC: 'Fone WhatsApp',
  ESTCIVIL: 'Estado Civil',
  CORPAC: 'Cor',
  NACIONPAC: 'Nacionalidade',
  SETORPAC: 'Status',
  INFORMACAO: 'Observações',
  LOCNASCPAC: 'Local de nascimento',
  EMAIL_PAC: 'E-mail',
  CODFUNC: 'Funcionário',
};

const PREFIXOS_IGNORADOS = new Set(['body', 'query', 'params']);

const chaveCampo = field => {
  const partes = String(field || '')
    .split('.')
    .filter(parte => parte && !PREFIXOS_IGNORADOS.has(parte));
  return partes[partes.length - 1] || '';
};

const rotulo = chave => ROTULOS[chave] || chave;

const humanizarMensagem = message => {
  const msg = String(message || '').trim();
  if (!msg) return '';

  const maximo = /^String must contain at most (\d+) character\(s\)$/.exec(msg);
  if (maximo) return `no máximo ${maximo[1]} caracteres.`;

  if (msg === 'Required') return 'obrigatório.';

  const desconhecido = /^Unrecognized key\(s\) in object: (.+)$/.exec(msg);
  if (desconhecido) {
    const citados = desconhecido[1].match(/'[^']+'/g) || [];
    const nomes = citados.map(item => rotulo(item.slice(1, -1)));
    return nomes.length
      ? `Campo não aceito: ${nomes.join(', ')}.`
      : 'Campo não aceito.';
  }

  return msg;
};

const linhaDoCampo = (chave, texto) => {
  if (/^[a-záàâãéêíóôõúç]/.test(texto)) return `${rotulo(chave)}: ${texto}`;
  return texto;
};

const interpretarErroPaciente = (error, fallback) => {
  const data = error && error.response && error.response.data;
  const details = data && Array.isArray(data.details) ? data.details : [];
  const porCampo = {};
  const outras = [];

  details.forEach(detail => {
    const texto = humanizarMensagem(detail && detail.message);
    if (!texto) return;

    const chave = chaveCampo(detail && detail.field);
    if (chave && ROTULOS[chave]) {
      porCampo[chave] = linhaDoCampo(chave, texto);
      return;
    }

    outras.push(texto);
  });

  if (!Object.keys(porCampo).length && !outras.length) {
    outras.push((data && data.error) || fallback);
  }

  return { porCampo, outras };
};

export default interpretarErroPaciente;
